import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jihua",
  "use": "icon-jihua-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-jihua\"><path d=\"M 501.76 0 C 225.28 0 0 225.28 0 501.76 S 225.28 1003.52 501.76 1003.52 S 1003.52 778.24 1003.52 501.76 S 778.24 0 501.76 0 Z M 204.8 808.96 l 53.248 -182.272 l 135.168 133.12 l -188.416 49.152 Z m 221.184 -69.632 L 288.768 593.92 l 335.872 -309.248 l 137.216 137.216 l -335.872 317.44 Z m 376.832 -337.92 l -141.312 -145.408 s 51.2 -61.44 73.728 -59.392 c 47.104 4.096 137.216 86.016 133.12 133.12 c -2.048 24.576 -65.536 71.68 -65.536 71.68 Z\" fill=\"#e6e6e6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/jihua.svg
// module id = 7nbC
// module chunks = 77